import { ArrowLeft, MapPin, Phone, User, Package, CheckCircle, Clock, AlertCircle, Navigation } from "lucide-react";
import { motion } from "framer-motion";
import { useCourierLanguage } from "../contexts/CourierLanguageContext";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function PackageDetail({
  packageId,
  navigateTo
}) {
  const {
    t,
    data
  } = useCourierLanguage();

  // Mock package data
  const packageData = {
    id: packageId || "PKG-2891",
    customer: {
      name: data.customerNames.aydin,
      phone: "+994 55 123 4567",
      email: "aydin.m@example.az"
    },
    address: data.addresses.nizami123,
    status: "pending",
    priority: "high",
    eta: "10:30",
    pickupLocation: "Bakı Mərkəzi Anbar",
    notes: "Gəlişdən əvvəl zəng edin. 3-cü mərtəbə, mənzil 15.",
    timeline: [{
      status: t.assigned,
      time: "08:00",
      completed: true
    }, {
      status: t.pickedUp,
      time: "09:15",
      completed: true
    }, {
      status: t.inTransit,
      time: "09:45",
      completed: true
    }, {
      status: t.delivered,
      time: "10:30 (TGV)",
      completed: false
    }]
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "min-h-screen bg---F5F6FA- pb-24",
    children: [/*#__PURE__*/_jsx("div", {
      className: "bg-gradient-to-r from---2D58AD- to---71A4F4- text-white p-4",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex items-center gap-4 mb-4",
        children: [/*#__PURE__*/_jsx("button", {
          onClick: () => navigateTo("packages"),
          className: "w-10 h-10 bg-white-20 backdrop-blur-sm rounded-xl flex items-center justify-center hover-bg-white-30 transition-colors",
          children: /*#__PURE__*/_jsx(ArrowLeft, {
            className: "w-6 h-6"
          })
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx("p", {
            className: "text-sm text-white-80",
            children: t.packageDetails
          }), /*#__PURE__*/_jsx("h1", {
            className: "text-xl font-bold",
            children: packageData.id
          })]
        })]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "p-4 neg-mt-2",
      children: [/*#__PURE__*/_jsxs(motion.div, {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        className: "bg-white rounded-2xl p-5 shadow-md mb-4",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex items-center justify-between mb-4",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "flex items-center gap-3",
            children: [/*#__PURE__*/_jsx("div", {
              className: "w-12 h-12 bg-neg-F59E0B--10 rounded-xl flex items-center justify-center",
              children: /*#__PURE__*/_jsx(Package, {
                className: "w-6 h-6 text---F59E0B-"
              })
            }), /*#__PURE__*/_jsxs("div", {
              children: [/*#__PURE__*/_jsx("p", {
                className: "text-sm text-neg-708094-",
                children: t.status
              }), /*#__PURE__*/_jsx("p", {
                className: "font-bold text---000080-",
                children: t.inTransit
              })]
            })]
          }), packageData.priority === "high" && /*#__PURE__*/_jsx("span", {
            className: "px-3 py-1 bg-red-50 text-red-600 text-sm font-semibold rounded-full",
            children: t.highPriority
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex items-center gap-2 text-sm text-neg-708094-",
          children: [/*#__PURE__*/_jsx(Clock, {
            className: "w-4 h-4"
          }), /*#__PURE__*/_jsxs("span", {
            children: ["TGV: ", packageData.eta]
          })]
        })]
      }), /*#__PURE__*/_jsxs(motion.div, {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        transition: {
          delay: 0.1
        },
        className: "bg-white rounded-2xl p-5 shadow-md mb-4",
        children: [/*#__PURE__*/_jsxs("h2", {
          className: "font-bold text---000080- mb-4 flex items-center gap-2",
          children: [/*#__PURE__*/_jsx(User, {
            className: "w-5 h-5"
          }), t.customerInformation]
        }), /*#__PURE__*/_jsxs("div", {
          className: "space-y-3",
          children: [/*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("p", {
              className: "text-sm text-neg-708094- mb-1",
              children: t.name
            }), /*#__PURE__*/_jsx("p", {
              className: "font-semibold text---000080-",
              children: packageData.customer.name
            })]
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("p", {
              className: "text-sm text-neg-708094- mb-1",
              children: t.phone
            }), /*#__PURE__*/_jsxs("div", {
              className: "flex items-center justify-between",
              children: [/*#__PURE__*/_jsx("p", {
                className: "font-semibold text---000080-",
                children: packageData.customer.phone
              }), /*#__PURE__*/_jsxs("a", {
                href: `tel:${packageData.customer.phone}`,
                className: "px-4 py-2 bg-neg-2D58AD- text-white rounded-lg flex items-center gap-2 hover-bg---000080- transition-colors",
                children: [/*#__PURE__*/_jsx(Phone, {
                  className: "w-4 h-4"
                }), t.call]
              })]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("p", {
              className: "text-sm text-neg-708094- mb-1",
              children: t.deliveryAddress
            }), /*#__PURE__*/_jsxs("div", {
              className: "flex items-start gap-2",
              children: [/*#__PURE__*/_jsx(MapPin, {
                className: "w-5 h-5 text-neg-2D58AD- flex-shrink-0 mt-0-5"
              }), /*#__PURE__*/_jsx("p", {
                className: "font-semibold text---000080-",
                children: packageData.address
              })]
            })]
          })]
        })]
      }), packageData.notes && /*#__PURE__*/_jsx(motion.div, {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        transition: {
          delay: 0.2
        },
        className: "bg---FEF3C7- border-2 border---F59E0B--20 rounded-2xl p-4 mb-4",
        children: /*#__PURE__*/_jsxs("div", {
          className: "flex items-start gap-3",
          children: [/*#__PURE__*/_jsx(AlertCircle, {
            className: "w-5 h-5 text---F59E0B- flex-shrink-0 mt-0-5"
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("p", {
              className: "font-semibold text---F59E0B- mb-1",
              children: t.deliveryNotes
            }), /*#__PURE__*/_jsx("p", {
              className: "text-sm text---92400E-",
              children: packageData.notes
            })]
          })]
        })
      }), /*#__PURE__*/_jsxs(motion.div, {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        transition: {
          delay: 0.3
        },
        className: "bg-white rounded-2xl p-5 shadow-md mb-4",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "font-bold text---000080- mb-4",
          children: t.deliveryTimeline
        }), /*#__PURE__*/_jsx("div", {
          className: "space-y-4",
          children: packageData.timeline.map((item, index) => /*#__PURE__*/_jsxs("div", {
            className: "flex items-start gap-3",
            children: [/*#__PURE__*/_jsxs("div", {
              className: "relative",
              children: [/*#__PURE__*/_jsx("div", {
                className: `w-10 h-10 rounded-full flex items-center justify-center ${item.completed ? "bg-neg-10B981- text-white" : "bg-gray-200 text-neg-708094-"}`,
                children: /*#__PURE__*/_jsx(CheckCircle, {
                  className: "w-5 h-5"
                })
              }), index < packageData.timeline.length - 1 && /*#__PURE__*/_jsx("div", {
                className: `absolute top-10 left-1-2 neg-translate-x-1-2 w-0-5 h-8 ${item.completed ? "bg-neg-10B981-" : "bg-gray-200"}`
              })]
            }), /*#__PURE__*/_jsxs("div", {
              className: "flex-1 pt-2",
              children: [/*#__PURE__*/_jsx("p", {
                className: `font-semibold ${item.completed ? "text---000080-" : "text-neg-708094-"}`,
                children: item.status
              }), /*#__PURE__*/_jsx("p", {
                className: "text-sm text-neg-708094-",
                children: item.time
              })]
            })]
          }, index))
        })]
      }), /*#__PURE__*/_jsxs(motion.div, {
        initial: {
          opacity: 0,
          y: 20
        },
        animate: {
          opacity: 1,
          y: 0
        },
        transition: {
          delay: 0.4
        },
        className: "bg-white rounded-2xl p-5 shadow-md mb-4",
        children: [/*#__PURE__*/_jsx("h2", {
          className: "font-bold text---000080- mb-3",
          children: t.pickupLocation
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex items-center gap-2 text-neg-708094-",
          children: [/*#__PURE__*/_jsx(MapPin, {
            className: "w-5 h-5 text-neg-2D58AD-"
          }), /*#__PURE__*/_jsx("p", {
            children: packageData.pickupLocation
          })]
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 safe-area-bottom",
      children: /*#__PURE__*/_jsxs("div", {
        className: "flex gap-3 max-w-md mx-auto",
        children: [/*#__PURE__*/_jsxs("button", {
          className: "flex-1 py-4 bg-white border-2 border-neg-2D58AD- text-neg-2D58AD- rounded-xl font-semibold flex items-center justify-center gap-2 hover-bg---DEEAFC- transition-colors",
          children: [/*#__PURE__*/_jsx(Navigation, {
            className: "w-5 h-5"
          }), t.navigate]
        }), /*#__PURE__*/_jsxs("button", {
          className: "flex-1 py-4 bg-neg-10B981- text-white rounded-xl font-semibold flex items-center justify-center gap-2 hover-bg---059669- transition-colors shadow-lg",
          children: [/*#__PURE__*/_jsx(CheckCircle, {
            className: "w-5 h-5"
          }), t.markDelivered]
        })]
      })
    })]
  });
}